module.exports = __webpack_public_path__ + "static/img/gonglu.feeb44b9.png";